module.exports = __webpack_public_path__ + "static/media/assa-plus.00cc0d25.svg";